import React from 'react';
import { SEO } from 'src/components';
import styled from '@emotion/styled';
import { baseStyle } from 'src/styles';

const Component: React.FCX = ({ className }) => (
  <main className={className}>
    <div className="policy-container">
      <header className="policy-header">
        <h1>カスタマーハラスメントに対する基本方針</h1>
        <div className="policy-date">2025年3月14日</div>
      </header>

      <section className="policy-section">
        <p className="policy-recipient">お取引先の皆様へ</p>
        <p className="policy-company">
          Aces株式会社<br />
          代表　白石　敬亮
        </p>
      </section>

      <section className="policy-section">
        <h2>カスタマーハラスメントに対する基本方針のご案内</h2>
        <p>
          このたび、Aces株式会社としてカスタマーハラスメントに対する基本方針を策定いたしましたので、お知らせいたします。
        </p>
      </section>

      <section className="policy-section">
        <h3>１．はじめに</h3>
        <p>
          Aces株式会社は、「常にお客様の"切り札"であり続ける」という基本理念の下、お客様の要望に真摯に対応し、より満足度の高いサービスの提供に向けて取り組んでおります。また、お客様からお寄せいただくご意見・ご要望は、当社のサービスの改善・品質向上において、大変貴重な機会と考えております。
        </p>
        <p>
          一方、一部のお客様の要求や言動の中には、従業員の人格を否定する暴言、脅迫、暴力など、従業員の尊厳を傷つけるものもございます。こうした社会通念に照らして著しく不当である行為は、従業員の就業環境を悪化させるだけでなく、安全・安心なサービスの提供にも悪影響を及ぼしかねない重大な問題であります。
        </p>
        <p>
          従業員の安全な就業環境を確保することで、従業員が安心して業務に取り組むことが可能となり、ひいては、お客様との関係をより良いものとすることにつながると考え、当社における「カスタマーハラスメントに対する基本方針」を定めました。
        </p>
      </section>

      <section className="policy-section">
        <h3>２．当社におけるカスタマーハラスメントの定義</h3>
        <p>
          当社では、カスタマーハラスメントを「お客様から従業員に対して行われる著しい迷惑行為であって、従業員の就業環境を害するもの」と定義します。
        </p>
        <p>
          具体的には、以下のような行為を指します。あくまで例示であり、これらに限られるものではありません。
        </p>
        <ul className="policy-list">
          <li>暴力行為</li>
          <li>暴言・侮辱・誹謗中傷</li>
          <li>威嚇・脅迫</li>
          <li>従業員の人格の否定・差別的な発言</li>
          <li>土下座の要求</li>
          <li>長時間の拘束</li>
          <li>社会通念上相当な範囲を超える対応の強要</li>
          <li>合理性を欠く不当・過剰な要求</li>
          <li>会社や従業員の信用を棄損させる内容や個人情報等をSNS等へ投稿する行為</li>
          <li>従業員へのセクシャルハラスメント、SOGI※ハラスメント、その他ハラスメント、つきまとい行為　など</li>
        </ul>
        <p className="policy-note">
          ※「SOGI」（ソジ）は、性的指向（sexual orientation）と性自認（gender identity）の頭文字をとった略称
        </p>
      </section>

      <section className="policy-section">
        <h3>３．カスタマーハラスメントへの対応（社内）</h3>
        <ul className="policy-list">
          <li>カスタマーハラスメントを受けた場合、従業員のケアを最優先します。</li>
          <li>従業員に対して、カスタマーハラスメントに関する知識・対処方法の研修を行います。</li>
          <li>カスタマーハラスメントに関する相談窓口の設置や警察・弁護士等の連携など体制を整備します。</li>
        </ul>
      </section>

      <section className="policy-section">
        <h3>４．カスタマーハラスメントへの対応（社外）</h3>
        <ul className="policy-list">
          <li>問題解決に当たっては、合理的かつ理性的な話し合いを行いますが、当社でカスタマーハラスメントに該当すると判断した場合、対応を打ち切り、以降のサービスの提供をお断りする場合があります。</li>
          <li>さらに、悪質と判断した場合、警察や外部の専門家（弁護士等）と連携の上、毅然と対応します。</li>
        </ul>
      </section>

      <section className="policy-section">
        <p className="policy-closing">以上</p>
      </section>
    </div>
  </main>
);

const StyledComponent = styled(Component)`
  ${baseStyle}

  min-height: 100vh;
  padding-top: 100px;
  background-color: #f5f5f5;

  .policy-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 60px 20px;
    line-height: 1.8;
    color: #333;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .policy-header {
    text-align: center;
    margin-bottom: 60px;
    padding-bottom: 40px;
    border-bottom: 2px solid #e0e0e0;

    h1 {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #000;

      @media (max-width: 768px) {
        font-size: 22px;
      }
    }
  }

  .policy-date {
    font-size: 16px;
    color: #666;
  }

  .policy-section {
    margin-bottom: 40px;

    h2 {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #000;
      border-left: 4px solid #000;
      padding-left: 16px;

      @media (max-width: 768px) {
        font-size: 18px;
      }
    }

    h3 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #000;

      @media (max-width: 768px) {
        font-size: 17px;
      }
    }

    p {
      font-size: 16px;
      margin-bottom: 16px;
      text-align: justify;

      @media (max-width: 768px) {
        font-size: 15px;
      }
    }
  }

  .policy-recipient {
    text-align: right;
    margin-bottom: 10px;
  }

  .policy-company {
    text-align: right;
    margin-bottom: 40px;
  }

  .policy-list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 20px;

    li {
      font-size: 16px;
      padding-left: 1.5em;
      position: relative;
      margin-bottom: 12px;

      @media (max-width: 768px) {
        font-size: 15px;
      }

      &:before {
        content: '•';
        position: absolute;
        left: 0.5em;
      }
    }
  }

  .policy-note {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
  }

  .policy-closing {
    text-align: right;
    font-weight: bold;
    margin-top: 40px;
  }
`;

export default ({ path }: { path: string }): JSX.Element => (
  <>
    <SEO
      title='カスタマーハラスメントに対する基本方針'
      pathname={path}
      description='Aces株式会社のカスタマーハラスメントに対する基本方針をご案内します。'
      noindex
    />
    <StyledComponent />
  </>
);
